let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("PAOD0")).then(() => parcelRequire('iplUS'));